module.exports = __webpack_public_path__ + "static/media/real_estate.408a18bd.png";